import FinancialRiskLevelDropdown from "components/dropdowns/reactselect/FinancialRiskLevelDropdown";
import React from "react";
import { getFinancialRiskLevel } from "utilities/enumutils";
interface Props {
  value: server.dto.FinancialRisk;
  onChange: (value: server.dto.FinancialRisk) => void;
}

export const FinancialRiskEdit = (props: Props) => {
  const financialRiskLevel = getFinancialRiskLevel(props.value.level);
  return <div className="flex-column gap">
    <div>
      <FinancialRiskLevelDropdown
        value={financialRiskLevel}
        onChange={level => props.onChange({ ...props.value, level: level.value })}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true
        }}
      />
    </div>
    <div>
      <textarea
        className="form-control"
        rows={3}
        value={props.value.comment ?? ""}
        onChange={e => props.onChange({ ...props.value, comment: e.target.value })}
        placeholder={RESX.GeneralLabels.Comment}
      />
    </div>
  </div>
}